var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{attrs:{"label":_vm.$t(_vm.label),"readonly":_vm.readonly,"disabled":_vm.disabled,"dense":_vm.dense,"hide-details":"","error":_vm.error},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})}
var staticRenderFns = []

export { render, staticRenderFns }